import * as Sentry from '@sentry/react';
import get from 'lodash/get';
export const pageMetaMiddleware = () => next => action => {
  if (__SERVER__ || !get(action, 'meta.pageMeta', false)) {
    return next(action);
  }
  try {
    const history = window.history;
    const pageMeta = get(action, 'payload.pageMeta', {});
    const newState = {
      ...history.state,
      ...pageMeta
    };
    if (pageMeta.title) {
      document.title = pageMeta.title;
      history.replaceState(newState, pageMeta.title);
    }
    const metas = {
      description: pageMeta.description,
      robots: pageMeta.robots
    };
    Object.keys(metas).forEach(name => {
      const content = metas[name];
      const DOMMeta = document.querySelector(`meta[name="${name}"]`);
      if (pageMeta[name]) {
        if (DOMMeta) {
          DOMMeta.content = content;
        } else {
          const newMeta = document.querySelector('head').createElement('meta');
          newMeta.name = name;
          newMeta.content = content;
        }
      } else if (DOMMeta) {
        DOMMeta.removeChild(DOMMeta);
      }
    });
  } catch (err) {
    Sentry.captureException(err);
  }
  return next(action);
};